

import React, { memo } from 'react';
import Icon from '../../../../Icon';
import { LIST_VIEW, GRID_VIEW, PITCH_LIST_VIEW } from '../../../constants/viewTypes';








function ListViewSelector({
  onChangeView,
  view,
  bothViewsAvailable,
  usePitchListView
}) {
  if (!bothViewsAvailable && !usePitchListView) {return null;}

  if (usePitchListView && view === PITCH_LIST_VIEW) {
    return (
      <Icon
        key="grid-icon"
        name="grid"
        onClick={onChangeView(GRID_VIEW)}
        color={view === GRID_VIEW ? 'denim' : 'regent'}
        hoverColor="denim"
        size={20} />);


  }

  if (usePitchListView && view === GRID_VIEW) {
    return (
      <Icon
        key="list-icon"
        name="list"
        onClick={onChangeView(PITCH_LIST_VIEW)}
        size={20}
        color={view === PITCH_LIST_VIEW ? 'denim' : 'regent'}
        hoverColor="denim" />);


  }

  if (bothViewsAvailable) {
    return (
      <>
        <Icon
          key="grid-icon"
          name="grid"
          onClick={onChangeView(GRID_VIEW)}
          color={view === GRID_VIEW ? 'denim' : 'regent'}
          hoverColor="denim"
          size={20} />

        <Icon
          key="list-icon"
          name="list"
          onClick={onChangeView(LIST_VIEW)}
          size={20}
          color={view === LIST_VIEW ? 'denim' : 'regent'}
          hoverColor="denim" />

      </>);

  }

  return null;
}

export default memo(ListViewSelector);